import React from 'react';
import { motion } from 'framer-motion';

const ProjectIntro = () => {
  return (
    <section 
      id="project-intro" 
      className="section-padding" 
      style={{
        background: 'linear-gradient(180deg, #050b14 0%, #081222 100%)',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <div 
        className="bg-glow-sphere" 
        style={{ 
          width: '30vw', 
          height: '30vw', 
          background: 'rgba(242, 184, 7, 0.05)', 
          top: '30%', 
          left: '-10%' 
        }} 
      />

      <div style={{ maxWidth: '1000px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <div className="text-center" style={{ marginBottom: '60px' }}>
          <span className="badge-gold">💡 Le Constat & La Vision</span>
          <h2 style={{
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            color: 'var(--mga-white)',
            marginTop: '10px'
          }}>
            Qu'est-ce que le projet <span style={{ color: 'var(--mga-gold)' }}>MonAlerte</span> ?
          </h2>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '40px',
          alignItems: 'center'
        }}>
          {/* Left Column - Storytelling */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.8 }}
          >
            <h3 style={{ 
              color: 'var(--mga-white)', 
              fontSize: '1.6rem', 
              marginBottom: '20px',
              fontFamily: 'var(--font-display)',
              borderLeft: '4px solid var(--mga-gold)',
              paddingLeft: '15px'
            }}>
              Pourquoi lancer ce projet aujourd'hui ?
            </h3>
            <p style={{ fontSize: '1.05rem', marginBottom: '20px' }}>
              Aujourd'hui, nous partageons tous un constat lucide : un sentiment grandissant d'insécurité. Les rues semblent de moins en moins sûres, parfois accompagnées d'une impression d'abandon, comme si aucune réponse technologique et humaine concrète n'était à notre portée immédiate.
            </p>
            <p style={{ fontSize: '1.05rem', marginBottom: '20px' }}>
              Face à cette fatalité, le projet <strong>MonAlerte</strong> est né. Notre but n'est pas simplement de proposer une application fixe, mais d'initier un projet évolutif destiné à s'améliorer continuellement au fil des avancées technologiques pour offrir des boucliers de protection toujours plus efficaces.
            </p>
          </motion.div>

          {/* Right Column - Mission Card (Glassmorphism) */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.8 }}
            className="glass-card"
            style={{
              padding: '40px 35px',
              borderLeft: '4px solid var(--mga-gold)',
              background: 'rgba(15, 39, 74, 0.3)'
            }}
          >
            <div style={{ fontSize: '3rem', color: 'var(--mga-gold)', lineHeight: 1, marginBottom: '10px' }}>“</div>
            <p style={{
              fontSize: '1.25rem',
              color: 'var(--mga-white)',
              fontWeight: 600,
              lineHeight: '1.6',
              marginBottom: '25px',
              fontFamily: 'var(--font-display)'
            }}>
              Utiliser la technologie pour redonner à chacun le contrôle de sa propre sécurité.
            </p>
            <p style={{
              color: 'var(--mga-slate-300)',
              fontSize: '0.95rem',
              lineHeight: '1.8',
              marginBottom: 0
            }}>
              Puisque le smartphone est désormais dans la poche de chacun d'entre nous, nous l'avons transformé en un outil de défense et de dissuasion collective. L'application MonAlerte est conçue pour gérer intelligemment et localement l'intégralité du processus d'alerte, de sa détection à la résolution.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ProjectIntro;
